import {ComponentPropsWithoutRef} from 'react';
import styled, {CSSObject, CSSProperties} from 'styled-components';
import {interceptProps} from '@/styled-components';

type TextAttrs = Pick<
  CSSObject,
  | 'fontSize'
  | 'fontWeight'
  | 'textDecoration'
  | 'lineHeight'
  | 'letterSpacing'
  | 'color'
  | 'opacity'
>;

export interface TypographyProps
  extends ComponentPropsWithoutRef<any>,
    TextAttrs {
  variant?: string;
  align?: CSSProperties['textAlign'];
  fontFamily?: 'Pretendard' | string;
  ellipsis?: boolean;
  nowrap?: boolean;
}

export const typographyStyle: TypographyProps = {
  medium10: {
    fontSize: 10,
    lineHeight: '12px',
  },
  medium12: {
    fontSize: 12,
    lineHeight: '14px',
  },
  medium14: {
    fontSize: 14,
    lineHeight: '18px',
  },
  medium16: {
    fontSize: 16,
    lineHeight: '20px',
  },
  medium20: {
    fontSize: 20,
    lineHeight: '24px',
  },
  bold12: {
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 700,
  },
  bold14: {
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 700,
  },
  bold16: {
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 700,
  },
  bold18: {
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 700,
  },
  bold24: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 700,
  },
  paragraph12: {
    fontSize: 12,
    lineHeight: '16px',
  },
  paragraph14: {
    fontSize: 14,
    lineHeight: '20px',
  },
};

const styles = ({variant}: {variant: string}) =>
  ({
    ...typographyStyle,
  }[variant as string]);

export const Typography = styled('span').withConfig({
  shouldForwardProp: interceptProps([
    'variant',
    'lineHeight',
    'color',
    'fontWeight',
    'fontFamily',
    'ellipsis',
    'align',
    'nowrap',
  ]),
})<TypographyProps>`
  ${styles as any};
  ${({fontFamily}) => fontFamily && `font-family: ${fontFamily} !important;`}
  ${({color}) => color && `color: ${color};`}
  ${({align}) => align && `text-align: ${align};`}
  ${({fontWeight}) => fontWeight && `font-weight: ${fontWeight};`}
  ${({textDecoration}) =>
    textDecoration && `text-decoration: ${textDecoration};`}
  ${({lineHeight}) => lineHeight && `line-height: ${lineHeight};`}
  ${({letterSpacing}) => letterSpacing && `letter-spacing: ${letterSpacing};`}
  ${({opacity}) => opacity && `opacity: ${opacity};`}
  ${({nowrap}) => nowrap && `white-space: nowrap;`}
  ${({ellipsis}) =>
    ellipsis &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}
`;
